import axios from 'axios';
import { PROCESS_STATUS } from '@/constants';

const state = () => ({
  currentService: {},
  currentDetail: {},
});

const getters = {};

const mutations = {
  SET_CURRENT_SERVICE(state, service) {
    state.currentService = service;
  },
  CLEAR_CURRENT_SERVICE(state) {
    state.currentService = {};
  },

  SET_CURRENT_DETAIL(state, detail) {
    state.currentDetail = detail;
  },
  CLEAR_CURRENT_DETAIL(state) {
    state.currentDetail = {};
  },
};

const actions = {
  submitService(_, { orderId, userId, roomId, roomNo, type, value }) {
    value.note = value.note.replace(/(?:\r\n|\r|\n)/g, '');
    console.log(orderId, userId, roomId, type, value);
    return new Promise((resolve, reject) => {
      axios
        .post('/Service', {
          roomId,
          roomNo,
          userId,
          type,
          value: JSON.stringify(value),
          orderId,
          status: PROCESS_STATUS.PENDING,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getProgress(_, userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/Service/GetServicesForUser/${encodeURIComponent(userId)}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getMenuImages(_, menuId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/MenuImage/GetMenuImagesForMenuId/${menuId}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
